"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1)
    },
    title: (0, _extends2.default)({}, theme.typography.body1, {
      paddingRight: theme.spacing(1)
    }),
    btn: {
      minWidth: 'initial',
      fontSize: 16,
      fontWeight: 400,
      '&:not(:last-of-type)': {
        marginRight: theme.spacing(0.5)
      }
    },
    active: {
      backgroundColor: 'rgba(206, 31, 36, 0.04)'
    }
  };
}, {
  name: 'CatalogueProductListPageSize'
});

function CatalogueProductListPageSize(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      onChange = _ref.onChange,
      rowsPerPage = _ref.rowsPerPage,
      sizes = _ref.sizes,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "onChange", "rowsPerPage", "sizes"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var handleChange = _react.default.useCallback(function (v) {
    return function () {
      onChange(v);
    };
  }, [onChange]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.title
  }, t('productListOrderSelectorButton/displayCountOfProducts')), (sizes || []).map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: "small",
      onClick: handleChange(i),
      key: index.toString(),
      className: (0, _clsx.default)(classes.btn, i === rowsPerPage && classes.active)
    }, i);
  }));
}

process.env.NODE_ENV !== "production" ? CatalogueProductListPageSize.propTypes = {
  classes: _propTypes.default.shape({
    active: _propTypes.default.string,
    btn: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  rowsPerPage: _propTypes.default.number,
  sizes: _propTypes.default.arrayOf(_propTypes.default.number)
} : void 0;
CatalogueProductListPageSize.defaultProps = {
  classes: undefined,
  className: undefined,
  onChange: undefined,
  rowsPerPage: undefined,
  sizes: [12, 16, 32, 48]
};
var _default = CatalogueProductListPageSize;
exports.default = _default;